import React from "react";
import AiFeaturePreview from "../../shared/Popup/AiFeaturePreview";

/** Right-side preview for AI Enhance — max-fit shared stage. */
const EnhancePreview = ({
  imageUrl = null,
  loading = false,
  loadingLabel = "Working…",
  emptyLabel = "Upload an image to preview enhance",
  transparent = false,
}) => (
  <AiFeaturePreview
    imageUrl={imageUrl}
    loading={loading}
    loadingLabel={loadingLabel}
    emptyLabel={emptyLabel}
    transparent={transparent}
  />
);

export default EnhancePreview;
